import { useEffect } from 'react'

interface RoleBasedCSSProps {
  userRole: number
}

const RoleBasedCSS = ({ userRole }: RoleBasedCSSProps) => {
  useEffect(() => {
    if (userRole === 0) {
      document.documentElement.classList.add('role-0')
    } else {
      document.documentElement.classList.remove('role-0')
    }
  }, [userRole])

  return null
}

export default RoleBasedCSS
